import Cookies from "universal-cookie";

const cookies = new Cookies();

export function getItemCookie(name) {
  return cookies.get(name);
}


export function deleteItemCookie(name) {
  return cookies.remove(name)
}

export function getWinnerPopup() {
  return cookies.get("winner-popup");
}

export function setWinnerPopup(status, timeExpired = 86400) {
  cookies.set("winner-popup", status, {
    path: "/",
    maxAge: timeExpired,
  });
  window.localStorage.setItem("winner-popup", JSON.stringify(status));
}

export function setCookie12House(name) {
  cookies.set(name, true, { path: "/", maxAge: 12 * 60 * 60 });
}

export function setCookieExpireEndOfDay(name, value = true) {
  const endOfDay = new Date();
  endOfDay.setHours(23, 59, 59, 999); // set thời gian hết hạn đến cuối ngày hôm nay

  cookies.set(name, value, {
    path: '/',
    expires: endOfDay,
  });
}

export function deleteCookieExpireEndOfDay(name) {
  cookies.remove(name, { path: "/" });
}

export function setCookieComponent({name, value = true, maxAge}) {
  try {
    return cookies.set(name, value, { path: "/", maxAge })
  } catch (error) {
    console.log("Error set Cookie: " + error);
  }
}

export function setCookieEvent() {
  cookies.set("hiddenGiftPopupEvent", true, {
    path: "/",
    maxAge: 12 * 60 * 60,
  });
}

export function setCookieChangePw() {
  cookies.set("hidden-popup-change-pw", true, {
    path: "/",
    maxAge: 24 * 60 * 60,
  });
}

export function setDailyLoginMiniGamePopup() {
  const now = new Date();
  const utcMidnight = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      23,
      59,
      59
    )
  );
  const secondsUntilUtcMidnight = Math.floor(
    (utcMidnight.getTime() - now.getTime()) / 1000
  );

  cookies.set("daily-login-minigame-popup", true, {
    path: "/",
    maxAge: secondsUntilUtcMidnight,
  });
}

export function getDailyLoginMiniGamePopup() {
  return cookies.get("daily-login-minigame-popup");
}